import ApiConstant from "../../constants/api.constants";
import ConsoleType from "../../constants/console-type.constant";
import Helpers from "../../utils/helpers";
import api from "../api";
import operations_table from './operations/stable_data/table.json';
import operations_barGraph from './operations/stable_data/bar_graph.json'
import operations_map from './operations/stable_data/map.json'

const getSurveyList = async (CustID: any, Year: any) => {

  let apiValues = '?Year=' + Year;

  if (CustID) {
    apiValues = apiValues + '&CustomerID=' + CustID;
  }
  return await api
    .get(ApiConstant.GetAOGIAllSurveyDetails + apiValues)
    .then(function (response: any) {
      return response.data;
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, ConsoleType.Error);
    });



  // let apiValues = '?SurveyYear=';
  //   let apiValues = '?SurveyYear=' + survey.surveyDate?.getFullYear();

  //   if (survey.customerID) {
  //     apiValues = apiValues + '&customerId=' + survey.customerID;
  //   }

  //   return await api
  //     .get(ApiConstant.getAOGISurveys + apiValues)
  //     .then(function (response: any) {
  //       return response.data;
  //     })
  //     .catch(function (error) {
  //       Helpers.ConsoleLog(error, ConsoleType.Error);
  //     });
};


const OperationTableData = async (startDate: any, endDate: any) => {

  // busniess logic
  let apiValues = '?startDate=' + startDate + '&endDate=' + endDate;

  return await api
    .get(process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA + '/api' + ApiConstant.getOperationSummary + apiValues)
    .then(function (response: any) {
      return response.data;
    })
    .catch(function (error) {
      return "error";
      // Helpers.ConsoleLog(error, ConsoleType.Error);
    });

  // return await new Promise((resolve, reject) => {
  //   resolve(operations_table)

  // })

};


const OperationsMaxLeakBySize = async (startDate: any, endDate: any) => {
  // busniess logic
  // let apiValues = '?startDate=' + startDate + '&endDate=' + endDate;
  // return await api
  //     .get("http://localhost:3001/products_bar_garph" + apiValues)
  //     .then(function (response: any) {
  //         return response.data.data;
  //     })
  //     .catch(function (error) {
  //         Helpers.ConsoleLog(error, ConsoleType.Error);
  //     });

  return await new Promise((resolve, reject) => {
    resolve(operations_barGraph.data)

  })
}

const OperationsMap = async (startDate: any, endDate: any) => {
  // busniess logic
  let apiValues = '?startDate=' + startDate + '&endDate=' + endDate;

  // return await api
  //     .get("http://localhost:3001/products_map" + apiValues)
  //     .then(function (response: any) {
  //         return response.data;
  //     })
  //     .catch(function (error) {
  //         Helpers.ConsoleLog(error, ConsoleType.Error);
  //     });

  return await new Promise((resolve, reject) => {
    resolve(operations_map)

  })
}






const DashboardService = {
  getSurveyList,
  OperationTableData,
  OperationsMaxLeakBySize,
  OperationsMap
};

export default DashboardService;